import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  access_token: null,
  refresh_token: null,
  role: null,
  isLoggedIn: false,
  is_new_user: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    // API response shape: { access, refresh, is_new_user, user }
    loginSuccess: (state, action) => {
      const { user, access, refresh, is_new_user } = action.payload;
      state.user = user;
      state.access_token = access;
      state.refresh_token = refresh;
      state.role = user?.user_type || user?.role;
      state.isLoggedIn = true;
      state.is_new_user = is_new_user ?? false;
    },

    logout: (state) => {
      state.user = null;
      state.access_token = null;
      state.refresh_token = null;
      state.role = null;
      state.isLoggedIn = false;
      state.is_new_user = false;
    },

    updateUser: (state, action) => {
      state.user = { ...state.user, ...action.payload };
    },

    // refresh token response: { data: { access } }
    updateTokens: (state, action) => {
      if (action.payload.access_token) {
        state.access_token = action.payload.access_token;
      }
      if (action.payload.refresh_token) {
        state.refresh_token = action.payload.refresh_token;
      }
    },
  },
});

export const { loginSuccess, logout, updateUser, updateTokens } =
  authSlice.actions;
export default authSlice.reducer;
